/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S18_P1_BInputs */

const tr_mesafeli_s18_p1_b = /** @type {(inputs: Mesafeli_S18_P1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'dir.`)
};

const en_mesafeli_s18_p1_b = /** @type {(inputs: Mesafeli_S18_P1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const de_mesafeli_s18_p1_b = /** @type {(inputs: Mesafeli_S18_P1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const ru_mesafeli_s18_p1_b = /** @type {(inputs: Mesafeli_S18_P1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Mesafeli_S18_P1_BInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s18_p1_b = /** @type {((inputs?: Mesafeli_S18_P1_BInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S18_P1_BInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s18_p1_b(inputs)
	if (locale === "de") return de_mesafeli_s18_p1_b(inputs)
	if (locale === "ru") return ru_mesafeli_s18_p1_b(inputs)
	return tr_mesafeli_s18_p1_b(inputs)
});